const pad = (value) => String(value).padStart(2, '0');

/**
 * Gera timestamp ISO 8601 preservando o offset GMT local do navegador.
 *
 * @returns {string} Timestamp como 2026-05-27T14:32:10-03:00
 */
export function getCurrentIsoWithTimezoneOffset() {
  const now = new Date();
  const offsetMinutes = -now.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absoluteOffset = Math.abs(offsetMinutes);
  const offsetHours = pad(Math.floor(absoluteOffset / 60));
  const offsetRemainderMinutes = pad(absoluteOffset % 60);

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
    + `T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
    + `${sign}${offsetHours}:${offsetRemainderMinutes}`;
}
